import Vue from 'vue';

import ApolloClient from 'apollo-boost';
import VueApollo from 'vue-apollo';

Vue.use(VueApollo);
export const apolloClient = new ApolloClient({
  uri: process.env.VUE_APP_API_URL,
  request: async operation => {
    const token = localStorage.getItem('token');

    if (token) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`
        }
      });
    }
  }
  // onError: error => {
  //   if (error && error.response && error.response.errors && error.response.errors.length) {
  //     alert(error.response.errors[0].message);
  //   }
  // }
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

export default apolloProvider;
